import { registerLoaders } from '@loaders.gl/core';
import { HTMLImageLoader } from '@loaders.gl/images';
import { global } from '../utils/globals';
import log from '../utils/log';
import jsonLoader from '../utils/json-loader';
import { initializeShaderModules } from '../shaderlib';
var version = typeof "7.3.15" !== 'undefined' ? "7.3.15" : global.DECK_VERSION || 'untranspiled source';
var STARTUP_MESSAGE = 'set deck.log.priority=1 (or higher) to trace attribute updates';
var existingVersion = global.deck && global.deck.VERSION;

if (existingVersion && existingVersion !== version) {
  throw new Error("deck.gl - multiple versions detected: ".concat(global.deck.VERSION, " vs ").concat(version));
}

if (!existingVersion) {
  log.log(0, "deck.gl ".concat(version, " - ").concat(STARTUP_MESSAGE))();
  global.deck = Object.assign(global.deck || {}, {
    VERSION: version,
    version: version,
    log: log
  });
  registerLoaders([jsonLoader, HTMLImageLoader]);
  initializeShaderModules();
}

export default global.deck;
//# sourceMappingURL=init.js.map